import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "flinks" }, [
  /*#__PURE__*/_createVNode("h5", { class: "font-weight-light" }, "FLINKS CONNECT")
], -1)
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = {
  style: {"width":"100%","border":"0"},
  src: "https://toolbox-iframe.private.fin.ag/?theme=light&customerName=FinTech&redirectUrl=https://flinks.io/contact/thank-you&consentEnable=true&innerRedirect=true&backgroundColor=f7f7f7&foregroundColor1=000&desktopLayout=true&headerEnable=false&institutionFilterEnable=true&demo=true",
  height: "760",
  scrolling: "no",
  ref: "flinks-iframe",
  id: "flinks-iframe"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("iframe", _hoisted_5, null, 512)
        ])
      ])
    ])
  ], 64))
}